var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.fields),function(field){return _c('div',{key:field.id,staticClass:"col-12 mb-3"},[_c(_vm.currentComponent(field.type),{tag:"component",attrs:{"options":field}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }